import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da1df7d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "id")
], -1))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onUpdate:modelValue", "data-col"]
const _hoisted_4 = ["onDblclick"]
const _hoisted_5 = ["onClick", "data-row"]
const _hoisted_6 = ["onClick", "onDblclick"]
const _hoisted_7 = ["data-col", "data-row", "onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _hoisted_1,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (_, index) => {
          return (_openBlock(), _createElementBlock("th", {
            key: index,
            onClick: ($event: any) => (_ctx.select(-1, index)),
            class: _normalizeClass({ selected: _ctx.selected.col == index })
          }, [
            (_ctx.editColumnIndex == index)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  class: "col-input",
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.cols[index]) = $event),
                  "data-col": index,
                  onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editColumn(-1)))
                }, null, 40, _hoisted_3)), [
                  [_vModelText, _ctx.cols[index]]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              onDblclick: ($event: any) => (_ctx.editColumn(index))
            }, _toDisplayString(_ctx.cols[index]), 41, _hoisted_4)
          ], 10, _hoisted_2))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (_, rowIndex) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: _normalizeClass({ selected: _ctx.selected.row == rowIndex }),
          key: rowIndex,
          onClick: _withModifiers(($event: any) => (_ctx.select(rowIndex, -1)), ["self"]),
          "data-row": rowIndex
        }, [
          _createElementVNode("td", null, [
            _createElementVNode("p", null, _toDisplayString(rowIndex + 1), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (_, colIndex) => {
            return (_openBlock(), _createElementBlock("td", {
              key: colIndex,
              class: _normalizeClass({ selected: _ctx.selected.col == colIndex }),
              onClick: ($event: any) => (_ctx.select(rowIndex, colIndex)),
              onDblclick: ($event: any) => (_ctx.editRow(rowIndex, colIndex))
            }, [
              (_ctx.editRowIndex == rowIndex && _ctx.editRowColumnIndex == colIndex)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    class: "row-input",
                    "data-col": colIndex,
                    "data-row": rowIndex,
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((_ctx.rows[rowIndex][colIndex]) = $event),
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editRow(-1, -1)))
                  }, null, 40, _hoisted_7)), [
                    [_vModelText, _ctx.rows[rowIndex][colIndex]]
                  ])
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_ctx.rows[rowIndex][colIndex]), 1)
            ], 42, _hoisted_6))
          }), 128))
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}